var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisableColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Power-button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75.243A.235.235 0 0 0 2.4.031a4.75 4.75 0 1 0 4.7 0 .235.235 0 0 0-.35.212v1.234a.261.261 0 0 0 .095.2 3.25 3.25 0 1 1-4.189 0 .261.261 0 0 0 .095-.2z",
    transform: "translate(4 4.589)",
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M1.5.75a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0z",
    transform: "translate(8 3)",
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 17.5a8.75 8.75 0 1 1 8.75-8.75 8.76 8.76 0 0 1-8.75 8.75zm0-16A7.25 7.25 0 1 0 16 8.75 7.258 7.258 0 0 0 8.75 1.5z",
    style: {
      fill: "#8c8d99"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableColored);
export default __webpack_public_path__ + "static/media/disable-colored.c9b8e813280ff45c624c38aacbec449a.svg";
export { ForwardRef as ReactComponent };